import React, {forwardRef, useEffect, useState} from 'react';
import {Link, Redirect} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {API_BASE_PATH} from "../../shared/restConstants";
import {InputLabel, MenuItem, Select, Slide} from "@material-ui/core";
import Header from "../component/Header/Header";
import QuantitySelector from "../component/quantitySelector";
import protonIconOffer from '../../shared/assets/icons/proton-icon-offer.svg'
import protonIconOfferRed from '../../shared/assets/icons/proton-icon-offer-red.svg'
import {
    clearCheckboxTires,
    setBrandsList,
    setClassificationList, setClearCheckboxSnackbar,
    setFilteredResult,
    setIndex,
    setLoadsList,
    setOriginalEquipment,
    setSearchResult,
    setSearchSort, setSortValue,
    setSpeedRatingList,
    setTireTypesList,
    updateResults
} from "../../core/redux/ActionCreator";
import QuoteButton from "../component/quoteButton";
import InfiniteScroll from 'react-infinite-scroll-component';
import dealerLocatorService from "../../shared/services/dealerLocatorService";
import FilterMenu from "./FilterMenu";
import Grid from "@material-ui/core/Grid";
import AddNewTires from "./AdditionalSearch/AddNewTires";
import Offer from "../component/Offers/offer";
import tireFinderWarranty from '../../shared/assets/icons/icon-tire-finder-warranty.svg'
import Analytics from "../../shared/util/analytics";
import FormControl from "@material-ui/core/FormControl";
import OfferModal from "./OfferModal";
import CheckBox from "./CheckBox/CheckBox";
import CompareButtonBottom from "./CompareButtonBottom";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert, {  } from '@material-ui/lab/Alert';

const Alert = forwardRef((props, ref) => <MuiAlert elevation={0} variant="filled" {...props} ref={ref} />);
function SlideTransition(props) {
    return <Slide {...props} direction="left" />;
}
function TireResults() {
    const DEFAULT_NUMBER_OF_ENTRIES = 3;
    const dispatch = useDispatch();
    const [toHome, setToHome] = useState(false);
    const bac = useSelector(state => state.dealerReducer.bac);
    const results = useSelector(state => state.searchResultReducer.results);
    const filteredResults = useSelector(state => state.searchResultReducer.filteredResults);
    const selected = useSelector(state => state.searchResultReducer.checkboxes);
    const sMake = useSelector(state => state.yearMakeModelReducer.sMake);
    const sModel = useSelector(state => state.yearMakeModelReducer.sModel);
    const sSize = useSelector(state => state.yearMakeModelReducer.sSize);
    const sYear = useSelector(state => state.yearMakeModelReducer.sYear);
    const sortValue = useSelector(state => state.searchResultReducer.sortValue);
    const [localTireResults, setLocalTireResults] = useState(filteredResults.slice(0, DEFAULT_NUMBER_OF_ENTRIES));
    const [hasMore, setHasMore] = useState(true);
    const resultsUpdated = useSelector(state => state.searchResultReducer.updateResult);
    const originalEquipment = useSelector(state => state.searchResultReducer.originalEquipment);
    const updateFilter = useSelector(state => state.searchResultReducer.updateFilter);
    const brand = useSelector(state => state.appParamsReducer.brand);
    const pathname = useSelector(state => state.appParamsReducer.pathname);
    const resultsFlag = useSelector(state => state.searchResultReducer.areResultsBeingRetrievedFlag);
    const analytics = Analytics();
    const spinner = useSelector(state => state.searchResultReducer.spinner);
    const isDealerSite = useSelector(state => state.dealerReducer.isDealerSite);
    const adobeFlag = useSelector(state => state.appParamsReducer.adobeScriptLoadFlag);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const resize = () => {
        setIsMobile(window.innerWidth < 768);
    };
    const snackbar = useSelector(state => state.searchResultReducer.snackbar);
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        dispatch(setClearCheckboxSnackbar({snackbar: false}));
    };

    //for analytics
    useEffect(() => {
        if (adobeFlag) {
            analytics.trackPage('search-results');
            // eslint-disable-next-line no-undef
            _satellite.track('search-results');
            console.log('Analytics Added for Page to DOM: Search Results using JQuery');
        }
        // eslint-disable-next-line
    }, [adobeFlag]);

    //for mobile resizing
    useEffect(() => {
        window.addEventListener("resize", resize);
    }, []);

    //used to update tire results
    useEffect(() => {
        if (sYear !== '' && sMake !== '' && sModel !== '' && sSize !== '' && bac !== 999999) {
            if (!spinner) {
                dealerLocatorService.getServicesByVehicle(bac, sYear, sMake, sModel.replaceAll('/', '_'), sSize.replace('/', '_'), true);
            }
        } else {
            setToHome(true);
        }
        // eslint-disable-next-line
    }, [brand, pathname, sYear, sMake, sModel, sSize, bac, spinner, dispatch]);

    //used to update local result state
    useEffect(() => {
        if (resultsFlag) {
            setHasMore(true);
        } else if (filteredResults.length >= DEFAULT_NUMBER_OF_ENTRIES) {
            setLocalTireResults(filteredResults.slice(0, DEFAULT_NUMBER_OF_ENTRIES));
            setHasMore(true);
        } else {
            setLocalTireResults(filteredResults.slice(0, filteredResults.length));
            setHasMore(false);
        }
        analytics.trackPage('search-results');
        // eslint-disable-next-line
    }, [resultsFlag, filteredResults]);

    //add dispatch to clear filters
    useEffect(() => {
        if (resultsUpdated || spinner) {
            //add dispatch to clear filters
            setLocalTireResults([]);
            dispatch(clearCheckboxTires(true));
            dispatch(setSearchResult([]));
            dispatch(updateResults({updateResult: false}));
            dispatch(setFilteredResult([]));
            dispatch(setOriginalEquipment([]));
            dispatch(setBrandsList([]));
            dispatch(setSpeedRatingList([]));
            dispatch(setLoadsList([]));
            dispatch(setTireTypesList([]));
            dispatch(setClassificationList([{'name': 'Original Equipment', 'selected': false}, {
                'name': 'Replacement',
                'selected': false
            }]));
            //removed compared tires when result updates
            dispatch(clearCheckboxTires(true));
        }
    }, [resultsUpdated, spinner, dispatch]);

    //used to update filters
    useEffect(() => {
        if (results.length !== 0 && filteredResults.length === 0 && !updateFilter) {
            results.sort(function (a, b) {
                return a['price'] - b['price']
            });
            let tempOE = [];
            let i;
            results.forEach(result => {
                if (result.originalEquipment === true) {
                    tempOE.push(result);
                }
            });
            tempOE.sort(function (a, b) {
                return b['price'] - a['price']
            });
            for (i = 0; i < results.length; i++) {
                if (results[i].originalEquipment === true) {
                    results.splice(i, 1);
                    i--;
                }
            }
            tempOE.forEach(result => {
                results.unshift(result);
            });
            dispatch(setOriginalEquipment(tempOE));
            dispatch(setFilteredResult([...results]));
            dispatch(setSortValue(''));

        }
    }, [results, dispatch,filteredResults, originalEquipment, updateFilter, sortValue]);

    if (toHome){ return <Redirect to="/"/>}

    function SortedResults() {
        const sortResults = type => {
            const types = {
                priceLH: 'priceLH',
                priceHL: 'priceHL',
                brandAZ: 'brandAZ',
                brandZA: 'brandZA',
                default: 'default'
            };
            const sortProperty = types[type];
            let sortedResults = [...filteredResults];
            if (sortProperty === 'priceLH') {
                sortedResults.sort(function (a, b) {
                    return a['price'] - b['price']
                });
            }
            if (sortProperty === 'priceHL') {
                sortedResults.sort(function (a, b) {
                    return b['price'] - a['price']
                });
            }
            if (sortProperty === 'brandAZ') {
                sortedResults.sort(function (a, b) {
                    return a.brand === b.brand ?
                        a.name === b.name ? 0 : a.name > b.name ? 1 : -1 :
                        a.brand > b.brand ? 1 : -1
                });

            }
            if (sortProperty === 'brandZA') {
                sortedResults.sort(function (a, b) {
                    return a.brand === b.brand ?
                        a.name === b.name ? 0 : a.name > b.name ? -1 : 1 :
                        a.brand > b.brand ? -1 : 1
                });
            }
            if(selected){
                sortedResults.forEach(item =>{ if(selected.includes(item.gmPartNum)){
                    item.selected = true}});
            }
            dispatch(setFilteredResult(sortedResults));
        };

        function handleChangeSort(event) {
            dispatch(setSearchSort(event.target.value));
            sortResults(event.target.value);
        }

        return (
            <div>
                <div className={'sortBy'}></div>
                <FormControl variant="outlined">
                    <InputLabel className="dropdownLabel" id="year-dropdown-label" style={{fontSize: '14'}} shrink={false}>
                        {sortValue === "Sort By" ? "Sort By:": ""}
                    </InputLabel>
                    <Select
                    labelId="year-dropdown-label"
                    value={sortValue}
                    className='stat-dropdown'
                    data-dtm={'search results'}
                    onChange={handleChangeSort}>
                        <MenuItem value="priceLH">Price: Low to High </MenuItem>
                        <MenuItem value="priceHL">Price: High to Low</MenuItem>
                        <MenuItem value="brandAZ">Brand: A to Z</MenuItem>
                        <MenuItem value="brandZA">Brand: Z to A</MenuItem>
                </Select>
                </FormControl>
            </div>
        )
    }

    function ResultsTitle(){
        return (
            <div style={{width: '100%'}}>
                <Grid container spacing={2} alignItems={'flex-end'}>
                    <Grid item xs={6}>
                      <span className={"resultsCounter"} > {filteredResults.length} Results for {sSize.toString().replace('_', '/')}</span>
                    </Grid>
                    <Grid item xs={6} >
                        <AddNewTires/>
                    </Grid>
                </Grid>

            </div>
        )
    }

    function DisplayResults(){
        const tires = localTireResults.map((value, index) => (
            <div className={"pxgoldresults"} key={index}>
                <CheckBox tireInfo={value}/>

                <div className={"flexLayout"}>
                    <div className={"stat-text-link"} data-dtm={"search results:" + value.brand + ":" + value.name}>
                        <Link to='/productDetail' onClick={() => HandleProductDetail(value.gmPartNum)}>
                            <div className={"tireImageResults"}>
                                <img className={"tireImageResults"} src={API_BASE_PATH + "blob/" + value.imageName}
                                     alt="Tire"/>
                            </div>
                        </Link>
                    </div>
                    <div className={"flexLayoutWithSpace"}>
                        <div className={"gridLayout"}>
                            <div className={"tireBrand"}>{value.brand}</div>
                            <div className={"tireName stat-text-link"}
                                 data-dtm={"search results:" + value.brand + ":" + value.name}>
                                <Link to='/productDetail'
                                      onClick={() => HandleProductDetail(value.gmPartNum)}>{value.name}</Link>
                            </div>
                            {value.originalEquipment === true ? <div className={"tireBrand"}>Original Equipment</div> :
                                <div className={"tireBrand"}>Replacement Tire</div>
                            }
                            <div className={"tireBrand"}>{value.tireType}</div>
                            <br/>
                            <div className={'hide-on-mobile'}>
                                {!isNaN(parseInt(value.warranty, 10)) ?
                                    <div className={'warrantyOffers'}><img src={tireFinderWarranty}
                                                                           alt={'Offer Tag'}/>{value.warranty + " mile warranty"}
                                    </div> : null}
                                <br/>
                                <div className={'resultDetails'}>
                                    {value.tireFinderPromoTitle !== null ?
                                    <>
                                        <div className={'resultsOffers'}>
                                            <div>
                                            {brand ==='gmc' ? <img src ={protonIconOfferRed} alt ={'Offer Tag'} />
                                                :   <img src={protonIconOffer} alt={'Offer Tag'}/>}
                                            </div>
                                            <div>{value.tireFinderPromoTitle + ' '}</div>
                                            <div className={'details'}>
                                                <OfferModal headerInfo={value.tireFinderPromoTitle}
                                                            offerBody={value.primaryOfferDetails}
                                                            effectiveDate={value.effectiveDate}
                                                            expirationDate={value.expirationDate}
                                                            offerDisclaimer={value.primaryPromoDisclaimer}/>
                                            </div>
                                        </div>
                                    </>
                                    : null
                                    }
                                </div>
                            </div>
                        </div>
                        {!isMobile &&
                        (
                            <QuantitySelector gmPartNum={value.gmPartNum} page='search' displayBelow={true}
                                              brand={value.brand} tireName={value.name} priceFailed={value.priceFailed}/>
                        )}
                    </div>
                    <br/>
                </div>
                <div className={'hide-on-desktop'}>
                    { !isNaN(parseInt(value.warranty, 10))? <div className={'warrantyOffers'}> <img src={tireFinderWarranty} alt={'Offer Tag'}/>{value.warranty + " mile warranty"}</div>:null}

                    <div className={'resultDetails'}>
                        {value.tireFinderPromoTitle !== null?
                            <>
                                <br/>
                                <div className={'resultsOffers'}>
                                    <div>{brand ==='gmc' ? <img src ={protonIconOfferRed} alt ={'Offer Tag'} />:<img src={protonIconOffer} alt={'Offer Tag'}/>}</div>
                                    <div>{value.tireFinderPromoTitle + ' '}</div>
                                    <div><OfferModal headerInfo={value.tireFinderPromoTitle}
                                                     offerBody={value.primaryOfferDetails}
                                                     effectiveDate={value.effectiveDate}
                                                     expirationDate={value.expirationDate}
                                                     offerDisclaimer={value.primaryPromoDisclaimer}/></div>
                                </div>
                            </>
                            : null
                        }
                    </div>
                    <br/>
                    <QuantitySelector gmPartNum={value.gmPartNum} page='search' displayBelow={false}
                                      brand={value.brand} tireName={value.name} priceFailed={value.priceFailed}/>
                </div>
                <br/>
                <br/>
                <div className={ isMobile ? 'buttonPlacement' : 'deskTopButtonPlacement'}>
                    <QuoteButton gmPartNum={value.gmPartNum} brand={value.brand} tireName={value.name}/>
                </div>
                {/*<div> {selected.length >= 2? <CompareButtonBottom/>: null} </div>*/}
            </div>
        ));

        function HandleProductDetail(gmPartNum) {
            dispatch(setIndex({gmPartNum:gmPartNum}));
        }

        function fetchMoreData() {
            if (localTireResults.length < filteredResults.length) {
                const currentIndexDisplayed = localTireResults.length - 1;
                let more = true;

                // Add one more due to slice not including end parameter
                let nextIndexToDisplay = currentIndexDisplayed + DEFAULT_NUMBER_OF_ENTRIES + 1;
                if (nextIndexToDisplay >= filteredResults.length - 1) {
                    nextIndexToDisplay = filteredResults.length;
                    more = false;
                }
                setTimeout(() => {
                    setLocalTireResults(localTireResults.concat(filteredResults.slice(currentIndexDisplayed + 1,
                        nextIndexToDisplay)));
                }, 500);
                setHasMore(more);
            } else {
                setHasMore(false);
            }
        }

        return (
            <>
            <div>{selected.length >=2 ? <CompareButtonBottom/>: null} </div>
            <InfiniteScroll
                dataLength={localTireResults.length}
                next={fetchMoreData}
                hasMore={hasMore}
                loader={<h4>Loading...</h4>}
                scrollableTarget={!isMobile ? "scrollableDiv" : "scrollableDivMobile"}
                endMessage={
                    <p style={{textAlign: 'center'}}>
                        {spinner && !hasMore ? <b>Loading...</b> : <b>All Tires Displayed!</b>}
                    </p>
                }
            >
                {tires}

            </InfiniteScroll>

            </>
        );
    }
    return (
        <div>
            <Offer/>
            <br/>
            <div>
                <Header title='Choose a Dealer' page={isDealerSite ? '/' : '/dealerLocator'} viewQuote={true}/>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right'}}
                    open={snackbar}
                    autoHideDuration={3000}
                    onClose={handleClose}
                    TransitionComponent={SlideTransition}>
                    <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                        Done! your selections have been cleared
                    </Alert>
                </Snackbar>
                {!isMobile &&
                (<>
                    <ResultsTitle/>
                    <br/>
                    <Grid container spacing={1} alignItems={'flex-end'}>
                        <Grid item xs={2} alignItems={"flex-start"}>
                            <SortedResults/>
                        </Grid>
                        <Grid item xs={3} alignItems={"flex-end"} justify={"flex-end"} alignContent={"flex-end"}>
                            <FilterMenu/>
                        </Grid>
                    </Grid>
                    {(filteredResults.length === 0 && updateFilter) ?
                        <div className={'noResults'}>
                            <p style={{textAlign: 'center'}}>
                                <h3>No results found.</h3>
                            </p>
                        </div> :
                        <div id="scrollableDiv" style={{height: 1050, overflow: "auto"}}><DisplayResults/>
                        </div> }
                </>)
                }
                {isMobile &&
                (<>
                    <ResultsTitle/>
                    <br/>
                    <Grid container spacing={1} alignItems={'flex-end'}>
                        <Grid item xs={9} alignItems={"flex-start"}>
                            <SortedResults/>
                        </Grid>
                        <Grid item xs={3} alignItems={"flex-end"} justify={"flex-end"} alignContent={"flex-end"}>
                            <FilterMenu/>
                        </Grid>
                    </Grid>
                    {(filteredResults.length === 0 && updateFilter) ?
                        <div className={'noResults'}>
                            <p style={{textAlign: 'center'}}>
                                <h3>No results found.</h3>
                            </p>
                        </div> :
                        <div id="scrollableDivMobile" style={{height: 750, overflow: "auto"}}><DisplayResults/>
                        </div>}
                </>)
                }
                <br/>
            </div>
        </div>
    );
}

export default TireResults
